import formatString from './formatString';

export const getOverrideMeta = (category, type, props) => {
  const activeFacets = props?.facets
      ?.filter?.((x) => !['cat1', 'cat2', 'cat3']?.includes(x.id))
      ?.filter?.((x) => x?.values.some((v) => v.selected));

  const activeFilters = activeFacets?.reduce?.((acc, curr) => {
    const selected = curr?.values?.filter?.((v) => v?.selected);
    let filters = acc;
    filters = [...acc, ...selected];
    return filters;
  }, []);

  const algoliaCategories = props?.searchState?.refinementList?.product_type?.map((pt) => pt.toLowerCase().replace(/\s/g, ''));
  const activeFilterIds = activeFilters
    ? activeFilters?.map?.((filter) => filter.id)
    : algoliaCategories ?? [];

  if (type === 'shop') {
    if (activeFilterIds?.includes('costumeaccessories') && activeFilterIds?.includes('costumes')) {
      if (
        (activeFilterIds?.includes('06m') || props?.variants?.includes('0-6m'))
        && (activeFilterIds?.includes('612m') || props?.variants?.includes('6-12m'))
        && (activeFilterIds?.includes('1224m') || props?.variants?.includes('12-24m'))
      ) {
        return {
          heading: 'Baby Halloween Costumes',
          title: 'Newborn, Infant & Baby Halloween Costumes | Maisonette',
          description: 'Include the newest member of the family in your Halloween festivities. Shop your favorite brands of newborn, infant and baby halloween costumes from Maisonette.'
        };
      }

      if (
        (activeFilterIds?.includes('24y') || props?.variants?.includes('2-4y'))
        && (activeFilterIds?.includes('46y') || props?.variants?.includes('4-6y'))
        && (activeFilterIds?.includes('68y') || props?.variants?.includes('0-6m'))
        && (activeFilterIds?.includes('8y') || props?.variants?.includes('0-6m'))
      ) {
        return {
          heading: 'Halloween Costumes for Girls & Boys',
          title: 'Halloween Costumes for Girls & Boys | Maisonette',
          description: 'Shop Maisonette\'s Halloween costumes for girls and boys. Whether they want to be a firefighter or a pink unicorn, this is your one-stop shop for all things Halloween.'
        };
      }

      return {
        heading: 'All Halloween Costumes',
        title: 'Shop All Halloween Costumes | Maisonette',
        description: 'From fairytales to superheroes and everything in-between, shop Maisonette\'s entire selection of Halloween costumes for babies and kids.'
      };
    }

    if (activeFilterIds?.includes('costumeaccessories')) {
      return {
        heading: 'Kids Halloween Costume Accessories',
        title: 'Kids Halloween Costume Accessories | Maisonette',
        description: 'Bring your kid\'s Halloween costume to life with halloween costume accessories like costume wigs, capes, fairy wings and more. Maisonette has you covered.'
      };
    }

    if (
      category === 'home_seasonal_halloween'
      && activeFilterIds?.includes('garlands')
      && activeFilterIds?.includes('papergoods')
      && activeFilterIds?.includes('party')
    ) {
      return {
        heading: 'Halloween Party Decor & Supplies',
        title: 'Halloween Party Decor, Table Decor & Supplies | Maisonette',
        description: 'Shop Maisonette\'s Halloween Party decor. Get festive with Halloween Table Decor, party supplies and more to make your home the spookiest on the block.'
      };
    }

    if (!activeFilters?.length) {
      if (category === 'baby') {
        return {
          heading: 'Baby Clothes',
          title: 'Baby Clothes - Newborn & More Baby Clothing | Maisonette',
          description: 'Maisonette is your one-stop shop for newborn, infant, and baby clothes. Shop baby clothing, essentials, and more from new trends to proven favorites.'
        };
      }
      if (category === 'baby_girlclothing') {
        return {
          heading: 'Baby Girl Clothing',
          title: 'Baby Girl Clothing - Newborn & More Baby Girl Clothes | Maisonette',
          description: 'Shop baby girl clothing hand-picked by Maisonette\'s marketplace. Get baby girl clothes for all ages from newborns to toddlers, all in one easy destination.'
        };
      }

      if (category === 'baby_girlclothing_rompers') {
        return {
          heading: 'Baby Girl Rompers',
          title: 'Baby Girl Rompers & Bodysuits | Maisonette',
          description: 'Make space for baby girl rompers from Maisonette. From classic baby girl bodysuits, Take Me Home sets, and more, keep her stylish from day one.'
        };
      }

      if (category === 'baby_girlclothing_dresses') {
        return {
          heading: 'Baby Girl Dresses',
          title: 'Baby Dresses - Newborn Baby Girl Dresses | Maisonette',
          description: 'Stop the search for the perfect baby dress, Maisonette has the selection you\'re looking for! Get newborn baby girl dresses and dress sets in our online shop.'
        };
      }

      if (category === 'baby_girlclothing_sleepwear') {
        return {
          heading: 'Baby Girl Pajamas & Sleepers',
          title: 'Baby Girl Pajamas, Sleepers & Nightgowns | Maisonette',
          description: 'Shop baby girl pajamas and sleepers that keep her cozy while she\'s dreaming. From newborn sleepers to baby girl nightgowns, find everything at Maisonette!'
        };
      }

      if (category === 'baby_girlclothing_swim') {
        return {
          heading: 'Baby Girl Swimsuits',
          title: 'Baby Girl Swimsuits - Infant & Baby Swimwear | Maisonette',
          description: 'Shop summer favorites including baby girl swimsuits at Maisonette. Our curation of infant and baby girl swimwear and bathing suits combine style and function.'
        };
      }

      if (category === 'baby_boyaccessories_bloomers') {
        return {
          heading: 'Baby Boy Bloomers',
          title: 'Shop Baby Boy Bloomers & Diaper Covers | Maisonette',
          description: 'Shop baby boy bloomers and diaper covers in Maisonette\'s Marketplace. From monogrammable styles and more, get your favorite brands from our one-stop shop.'
        };
      }

      if (category === 'baby_boyaccessories_socks') {
        return {
          heading: 'Baby Boy Socks',
          title: 'Baby Boy Socks - Newborn & Baby Socks | Maisonette',
          description: 'Discover Maisonette\'s selection of baby boy and newborn boy socks. From individual pairs to multi-packs and gift boxes, shop all newborn and baby boy socks.'
        };
      }

      if (category === 'baby_boyclothing') {
        return {
          heading: 'Baby Boy Clothing',
          title: 'Baby Boy Clothing - Newborn & Baby Boy Clothes | Maisonette',
          description: 'Shop newborn and baby boy clothes from Maisonette. Browse our one-stop shop for your favorite baby boy clothing brands that keep him stylish from day one.'
        };
      }

      if (category === 'baby_boyclothing_swim') {
        return {
          heading: 'Baby Boy Swimwear',
          title: 'Baby Boy Swimwear, Swim Trunks & Swimsuits | Maisonette',
          description: 'Dive in with baby boy swimwear at Maisonette. Shop baby boy swim trunks and swimsuits in bright colors and patterns for your little man\'s pool-side summer.'
        };
      }

      if (category === 'kids') {
        return {
          heading: 'Kids Clothes',
          title: 'Kids Clothes - Shop Children\'s Clothing | Maisonette',
          description: 'Maisonette is your one-stop shop for kids clothes including boys and girls clothing, accessories and more. Shop children\'s clothing from your favorite brands.'
        };
      }

      if (category === 'kids_girlclothing_swim') {
        return {
          heading: 'Girls Swimsuits',
          title: 'Girls Swimsuits, Swimwear & Bathing Suits | Maisonette',
          description: 'Shop our curated selection of little girls swimsuits and swimwear at Maisonette. Your favorite girls bathing suits will keep them feeling cool in the pool.'
        };
      }

      if (category === 'kids_boyclothing_swim') {
        return {
          heading: 'Boys Swimwear',
          title: 'Boys Swim Trunks, Swimwear & Bathing Suits | Maisonette',
          description: 'Shop Maisonette\'s selection of boys swim trunks and swimwear. Keep your little swimmer stylish this summer in the latest boys swimsuits and bathing suits.'
        };
      }

      if (category === 'home_seasonal_halloween') {
        return {
          heading: 'Halloween Home Decor',
          title: 'Halloween Decor - Indoor Home Decor | Maisonette',
          description: 'Bring the festivities indoors with Maisonette\'s Halloween decor. From festive fabric and velvet pumpkins to haunted houses and more, shop Halloween home decor.'
        };
      }

      if (category === 'home_seasonal') {
        return {
          heading: 'Home Seasonal Shop',
          title: 'Home Seasonal Shop - Christmas, Hanukkah & More | Maisonette',
          description: 'Discover Maisonette\'s entire selection of holiday and seasonal décor, accents, and more with our Home Seasonal Shop. From table settings to ornaments, get it here.'
        };
      }

      if (category === 'home_seasonal_thanksgiving') {
        return {
          heading: 'Thanksgiving Décor',
          title: 'Thanksgiving Home Décor - Table Décor & More | Maisonette',
          description: 'From Thanksgiving table décor to wreaths, centerpieces and more, Maisonette is your one-stop shop for decorations for Thanksgiving. Shop Thanksgiving décor.'
        };
      }

      if (category === 'home_seasonal_accentsdecor') {
        return {
          heading: 'Seasonal Home Décor',
          title: 'Christmas, Hanukkah & Seasonal Home Décor | Maisonette',
          description: 'Shop Christmas, Hanukkah, and seasonal home décor for accents that bring out the details in your decorating. Make your home festive with Maisonette.'
        };
      }

      if (category === 'home_seasonal_adventcalendars') {
        return {
          heading: 'Kids Advent Calendars',
          title: 'Kids Advent Calendars | Maisonette',
          description: 'Start the tradition of having an advent calendar for your kids. From chocolate-filled to paper and other crafty styles, shop advent calendars from Maisonette.'
        };
      }

      if (category === 'home_seasonal_hanukkah') {
        return {
          heading: 'Hanukkah Home Décor',
          title: 'Hanukkah Home Décor, Table Settings, Candle Holders & More | Maisonette',
          description: 'Shop Maisonette\'s curated selection of Hanukkah Home Décor including table settings, candles & candle holders, dreidels, menorahs, and more.'
        };
      }

      if (category === 'home_seasonal_nutcrackers') {
        return {
          heading: 'Christmas Nutcrackers',
          title: 'Decorative Christmas Nutcrackers | Maisonette',
          description: 'Shop Maisonette\'s wooden decorative Christmas nutcrackers, each a collection item and beautiful gift option for lovers of The Nutcracker and the ballet.'
        };
      }
      if (category === 'home_seasonal_ornamentstoppers') {
        return {
          heading: 'Christmas Ornaments & Tree Toppers',
          title: 'Christmas Ornaments & Tree Toppers | Maisonette',
          description: 'Shop Maisonette\'s selection of Christmas Ornaments and Tree Toppers. Your one-stop shop for seasonal home décor from your favorite kids brands and more.'
        };
      }
      if (category === 'home_seasonal_papergoods') {
        return {
          heading: 'Wrapping Paper, Gift Tags & More',
          title: 'Wrapping Paper, Gift Tags & More | Maisonette',
          description: 'Your gift will make a statement before its even unwrapped with Maisonette\'s Seasonal Paper Goods. Shop wrapping paper, gift tags, paper decor and more.'
        };
      }
      if (category === 'home_seasonal_partytabletop') {
        return {
          heading: 'Holiday Table Décor & Party Supplies',
          title: 'Holiday Table Décor & Party Supplies - Christmas, Halloween & More | Maisonette',
          description: 'Shop Maisonette\'s Holiday Table Décor and Party Supplies. From Christmas table decorations to Halloween and more, get all of your seasonal party needs.'
        };
      }
      if (category === 'home_seasonal_stockingstreeskirts') {
        return {
          heading: 'Christmas Stockings & Tree Skirts',
          title: 'Christmas Stockings & Tree Skirts | Maisonette',
          description: 'Bring out the magic of the holidays with Christmas stockings and tree skirts. Shop Maisonette\'s curated selection of holiday home décor and more.'
        };
      }
      if (category === 'home_seasonal_wreathsgarlands') {
        return {
          heading: 'Wreaths & Garlands',
          title: 'Wreaths & Garlands - Christmas, Fall & More | Maisonette',
          description: 'Shop Maisonette\'s holiday wreaths and garlands. From fall and Christmas wreaths to wooden beaded garlands, we\'re your one-stop shop for holiday home décor.'
        };
      }

      if (category === 'play' && (props?.filters?.includes('sprice:[21300,73600]') || props?.variants?.includes('price:21300-73600'))) {
        return {
          heading: 'Over the Top Gifts for Kids',
          title: 'Over the Top Gifts for Kids | Maisonette',
          description: 'Shop Maisonette\'s high quality and over the top inspired gifts for kids. Created by your favorite brands, make this season of giving unforgettable.'
        };
      }
    } else if (activeFilters?.length === 1 || props?.algoliaCategories) {
      const [{ id, name }] = activeFilters;

      const cat1 = category?.split?.('_')?.[0];

      if (cat1 === 'baby') {
        const meta = (t1, t2, t3) => ({
          title: `${t1} ${t2 === 'Slip Ons' ? 'Slip-Ons' : t2} - Shop ${t3} | Maisonette`,
          description: `Shop ${t1} ${t2 === 'Slip Ons' ? 'Slip-Ons' : t2} from your favorite newborn, infant and baby brands at Maisonette. Your one-stop shop for ${t3} and more.`
        });

        const clothingCategories = [
          'onesies',
          'leggings',
          'overalls',
          'rashguards',
          'sweaterscardigans',
          'poloshirts',
          'vests',
          'snowsuits'
        ];

        const accessoriesCategories = [
          'boots',
          'bowtiesties',
          'cribshoes',
          'slipons',
          'sneakers'
        ];

        const bathCategories = [
          'bodymoisturizers',
          'robes',
          'bodycleansers',
          'supplements'
        ];

        if (category === 'baby_boyclothing' && clothingCategories?.includes(id)) return meta('Baby Boy', name, 'Baby Clothes');
        if (category === 'baby_girlclothing' && [...clothingCategories, 'coverups']?.includes(id)) return meta('Baby Girl', name, 'Baby Clothes');

        if (category === 'baby_boyaccessories' && accessoriesCategories?.includes(id)) return meta('Baby Boy', name, 'Baby Accessories');
        if (category === 'baby_girlaccessories' && [...accessoriesCategories, 'dressshoes', 'maryjanes']?.includes(id)) return meta('Baby Girl', name, 'Baby Accessories');

        if (category === 'baby_bathbody' && bathCategories?.includes(id)) return meta('Baby', name, 'Baby Bath & Body');
      }

      if (cat1 === 'kids') {
        const meta = (t1, t2, t3, t4) => ({
          title: `${t1} ${t2} - Shop ${t4} | Maisonette`,
          description: `Shop ${t1} ${t2} and ${t3} from your favorite kid and toddler brands at Maisonette. Your one-stop shop for ${t4} and more.`
        });

        const clothingCategories = [
          'jeans',
          'overalls',
          'parkas',
          'poloshirts',
          'rashguards',
          'snowpants',
          'snowsuits',
          'sweatpants',
          'vests'
        ];

        const shoeCategories = [
          'boots',
          'loafers',
          'rainboots',
          'sandals',
          'sneakers'
        ];

        const bathCategories = [
          'robes',
          'bathsaltssoaks',
          'shampoos',
          'conditioners',
          'costumes'
        ];

        if (category === 'kids_boyclothing') {
          if ([...clothingCategories, 'blazers', 'buttondowns', 'coats']?.includes(id)) return meta('Boys\'', name, 'Clothes', 'Kids Clothes');
          if (['puffersdownjackets', 'sweaterscardigans', 'suitsseparates']?.includes(id)) {
            return {
              title: `Boys' ${name} - Shop Kids Clothes | Maisonette`,
              description: `Shop Boys' ${name} from your favorite kid and toddler brands at Maisonette. Your one-stop shop for Kids Clothes and more.`
            };
          }
        }

        if (category === 'kids_girlclothing') {
          if ([...clothingCategories, 'boots', 'coverups', 'cribshoes', 'dressshoes', 'maryjanes', 'playdresses', 'slipons', 'sneakers', 'leggings', 'underwear', 'woolcoats']?.includes(id)) return meta('Girls\'', name, 'Clothes', 'Kids Clothes');
          if (['puffersdownjackets', 'sweaterscardigans']?.includes(id)) {
            return {
              title: `Girls' ${name} - Shop Kids Clothes | Maisonette`,
              description: `Shop Girls' ${name} from your favorite kid and toddler brands at Maisonette. Your one-stop shop for Kids Clothes and more.`
            };
          }
        }

        if (category === 'kids_boyaccessories') {
          if ([...shoeCategories, 'oxfords']?.includes(id)) {
            return {
              title: `Boys' ${name} - Shop Kids Accessories | Maisonette`,
              description: `Shop Boys' ${name} and Shoes from your favorite kid and toddler brands at Maisonette. Your one-stop shop for Kids Shoes and more.`
            };
          }

          if (['lunchbags', 'skigoggles']?.includes(id)) {
            return meta('Boys\'', id === 'lunchbags' ? 'Lunch Bags' : name, 'Accessories', 'Kids Accessories');
          }
        }

        if (category === 'kids_girlaccessories') {
          if ([...shoeCategories, 'dressshoes', 'flats']?.includes(id)) {
            return {
              title: `Girls' ${name} - Shop Kids Accessories | Maisonette`,
              description: `Shop Girls' ${name} and Shoes from your favorite kid and toddler brands at Maisonette. Your one-stop shop for Kids Shoes and more.`
            };
          }

          if (['charms', 'earrings', 'lunchbags', 'maryjanes', 'umbrellas']?.includes(id)) {
            return meta('Girls\'', id === 'lunchbags' ? 'Lunch Bags' : name, 'Accessories', 'Kids Accessories');
          }
        }

        if (category === 'kids_bathbody' && bathCategories?.includes(id)) {
          return {
            title: `Kids ${name} - Shop Home Bath & Body | Maisonette`,
            description: `Shop Maisonette's curated selection of Kids ${name}. Your one-stop shop for Bath & Beauty from your favorite kids brands and more.`
          };
        }
      }

      if (cat1 === 'play') {
        if (category === 'play_kids') {
          const meta = (t1, t2 = 'Kids') => ({
            title: `${t1} - Shop ${t2} Toys | Maisonette`,
            description: `Shop ${t1 === 'Play Costumes' ? 'Costumes' : t1} from your favorite baby, toddler and kid brands at Maisonette. Your one-stop shop for Kids Toys and more.`
          });

          if (id === 'costumes') return meta('Play Costumes');
          if (id === 'makeup') return meta('Play Make-up');
          if (id === 'woodens') return meta('Wooden Toys', 'Kids & Baby');
        }

        if (category === 'play_outdoor') {
          const meta = (t1, t2 = 'Toys', t3) => ({
            title: `${t1} - Shop ${t2} | Maisonette`,
            description: `Shop ${t3} from your favorite baby, toddler and kid brands at Maisonette. Your one-stop shop for Kids Toys and more.`
          });

          if (id === 'goggles') return meta('Goggles for Swimming & More', undefined, 'Swim Goggles');
          if (id === 'helmets') return meta('Kids Bike Helmets & More', undefined, name);
          if (id === 'poolfloats') return meta('Pool Floats', 'Kids & Baby Pool Toys', name);
        }
      }

      if (cat1 === 'home') {
        if (category === 'home_decor') {
          const meta = (t1, t2) => ({
            title: `${t1} - Shop ${t2} | Maisonette`,
            description: `Shop Maisonette's curated selection of ${t1}. Your one-stop shop for Home and Nursery Décor from your favorite kids brands and more.`
          });

          if (id === 'wallpaper') return meta(name, 'Home & Nursery Décor');
          if (id === 'decorations') return meta(name, 'Home & Nursery Décor');
          if (id === 'mobiles') return meta('Baby Mobiles', 'Nursery Décor');
          if (id === 'drinkware') {
            return {
              title: 'Glasses & Drinkware - Shop Home Décor | Maisonette',
              description: 'Shop Maisonette\'s curated selection of Glasses & Drinkware. Your one-stop shop for Home Décor from your favorite kids brands and more.'
            };
          }
        }

        if (category === 'home_furniture') {
          if (id === 'teepees') {
            return ({
              title: 'Kids Teepees - Shop Home Furniture | Maisonette',
              description: 'Shop Maisonette\'s curated selection of Kids Teepees. Your one-stop shop for Home Furniture from your favorite kids brands and more.'
            });
          }

          if (id === 'travelcribs') {
            return ({
              title: 'Travel Cribs - Shop Baby Furniture & Gear | Maisonette',
              description: 'Shop Maisonette\'s curated selection of Travel Cribs. Your one-stop shop for Home Furniture from your favorite kids brands and more.'
            });
          }
        }

        if (category === 'home_beddingbath') {
          const meta = (t1, t2 = false) => ({
            title: t2 ? `${t1} - Shop Home Bath & Beauty | Maisonette` : `${t1} | Maisonette`,
            description: `Shop Maisonette's curated selection of ${t1 === 'Bath Tub Curtains, Mats, & Drapes' ? 'Bath Tub Curtains, Mats, and Drapes' : t1}. Your one-stop shop for Bath and Beauty from your favorite kids brands and more.`
          });

          if (id === 'cribsheets') return meta(name, true);
          if (id === 'tubs') return meta('Bath Tub Curtains, Mats, & Drapes');
          if (id === 'cribskirts') return meta(name, true);
        }
      }

      if (cat1 === 'gear') {
        const meta = (t1) => ({
          title: `${t1} - Shop Gear | Maisonette`,
          description: `Shop Maisonette's curated selection of ${t1}. Your one-stop shop for Gear from your favorite kids brands and more.`
        });

        const gearCategories = [
          'babymonitors',
          'boosterseats',
          'bottles',
          'burpcloths',
          'doublestrollers',
          'foodstorage',
          'headphones',
          'nursingpillows',
          'pacifiers',
          'sippycups',
          'strolleraccessories'
        ];

        if (gearCategories?.includes(id)) return meta(name);
      }
    }

    const cats = category?.split?.('_');
    const gender = (() => {
      if (cats?.[1]?.includes('boy')) return 'Boy';
      if (cats?.[1]?.includes('girl')) return 'Girl';
      return null;
    })();

    const facet = activeFacets?.length === 1
      ? activeFacets[0]?.values?.find((x) => x?.selected)?.name
      : null;

    const subCategory = (() => {
      if (activeFacets?.some((x) => x.id === 'category') && activeFacets?.find((x) => x.id === 'category')?.values?.filter((x) => x.selected).map((x) => x.name) === facet) {
        return null;
      }
      return props?.facets?.find((x) => x.id === 'cat3')?.values?.find((x) => x.selected)?.name;
    })();

    const categoryWithoutGender = (() => {
      if (!props?.facets && props?.algoliaCategories) {
        return formatString('capitlize', cats[1]?.replace(/Girl|Boy/, '')?.trim());
      }
      const cat = props?.facets?.find((x) => x.id === 'cat2')?.values?.find((x) => x.id === `${cats?.[0]}_${cats?.[1]}`);
      return cat ? cat?.name?.replace(/Girl|Boy/, '').trim() : null;
    })();

    const facetIsCat = activeFacets?.[0]?.id === 'category';
    const facetIsGender = activeFacets?.[0]?.id === 'gender';
    const facetNoUnisex = facetIsGender ? facet?.replace(/Unisex|unisex/, '') : facet;

    const showSubCat = !facetIsCat || activeFilters?.length > 1;
    const showFacet = facet && !facetIsGender && activeFilters.length <= 1;
    const topNav = props?.facets?.find((x) => x.id === 'cat1')?.values?.find((x) => x.selected)?.name;
    const formatCat = (cat) => {
      if (props?.searchState?.hierarchicalMenu) {
        // map category to get name
        const categories = props?.searchState?.hierarchicalMenu['categories.lvl0']?.split(' > ');
        return categories.filter((c) => c.toLowerCase().replace(/\s/g, '') === cat);
      }
      return cat.split('&').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' & ');
    };
    if (cats?.length === 3 && cats[0] === 'baby') {
      let title = 'Baby';
      if (gender) title += ` ${gender}`;
      if (showFacet) title += ` ${facet}`;
      if (!showFacet) title += ` ${formatCat(cats[2])}`;
      if (subCategory && showSubCat) title += ` ${subCategory}`;
      title += ' - Shop Baby';
      if (categoryWithoutGender) title += ` ${categoryWithoutGender}`;
      title += ' | Maisonette';

      let description = 'Shop Baby';
      if (gender) description += ` ${gender}`;
      if (showFacet) description += ` ${facet}`;
      if (!showFacet) description += ` ${formatCat(cats[2])}`;
      if (subCategory && showSubCat) description += ` ${subCategory}`;
      description += ' from your favorite newborn, infant and baby brands at Maisonette. Your one-stop shop for Baby';
      if (categoryWithoutGender) description += ` ${categoryWithoutGender}`;
      description += ' and more.';

      let heading = 'Baby';
      if (gender) heading += ` ${gender}`;
      if (showFacet) heading += ` ${facet}`;

      if (subCategory && showSubCat) heading += ` ${subCategory}`;

      return {
        heading,
        title,
        description: description.replace?.(/&/g, 'and')
      };
    }

    if (cats?.length === 3 && cats[0] === 'play' && activeFacets?.length === 0) {
      let title = '';
      if (categoryWithoutGender) title += `${categoryWithoutGender} `;
      if (subCategory) title += `${subCategory} `;
      title += '- Shop Toys | Maisonette';

      let description = 'Shop';
      if (categoryWithoutGender) description += ` ${categoryWithoutGender}`;
      if (subCategory) description += ` ${subCategory}`;
      description += ' from your favorite baby, toddler and kid brands at Maisonette. Your one-stop shop for';
      if (categoryWithoutGender) description += ` ${categoryWithoutGender}`;
      description += ' Toys and more.';

      const heading = subCategory ? `${subCategory}` : null;

      return {
        heading,
        title,
        description: description.replace?.(/&/g, 'and')
      };
    }

    if (cats?.length === 3 && cats[0] === 'kids') {
      let title = gender ? `${gender}s'` : '';
      if (showFacet) title += ` ${facet}`;
      if (!showFacet && props?.algoliaCategories) title += ` ${formatCat(cats[2])}`;
      if (subCategory && showSubCat) title += ` ${subCategory}`;
      title += ' - Shop Kids';
      if (categoryWithoutGender) title += ` ${categoryWithoutGender}`;
      title += ' | Maisonette';

      let description = 'Shop';
      if (gender) description += ` ${gender}s'`;
      if (showFacet) description += ` ${facet}`;
      if (!showFacet && props?.algoliaCategories) description += ` ${formatCat(cats[2])}`;
      if (subCategory && showSubCat) description += ` ${subCategory}`;
      description += ' and';
      if (categoryWithoutGender) description += ` ${categoryWithoutGender}`;
      description += ' from your favorite kid and toddler brands at Maisonette. Your one-stop shop for Kids';
      if (categoryWithoutGender) description += ` ${categoryWithoutGender}`;
      description += ' and more.';

      let heading = gender ? `${gender}s'` : '';

      if (showFacet) heading += ` ${facet}`;
      if (!showFacet && props?.algoliaCategories) heading += ` ${formatCat(cats[2])}`;
      if (subCategory && showSubCat) heading += ` ${subCategory}`;

      return {
        heading,
        title,
        description: description.replace?.(/&/g, 'and')
      };
    }

    if (cats?.length === 3 && ['gifts', 'home', 'whatsnew']?.includes(cats?.[0])) {
      let title = '';
      if (facetNoUnisex && activeFilters.length <= 1) title += `${facetNoUnisex} `;
      if (subCategory && showSubCat) title += `${subCategory} `;
      else if (props?.algoliaCategories) title += `${formatCat(cats[2])} `;

      title += title === '' ? 'Shop' : '- Shop';

      if (topNav) title += ` ${topNav}`;
      if (!topNav && props?.algoliaCategories) title += ` ${formatString('capitalize', cats[0])}`;
      if (categoryWithoutGender && cats?.[0] !== 'whatsnew') title += ` ${formatCat(categoryWithoutGender)}`;
      title += ' | Maisonette';

      let description = 'Shop Maisonette\'s curated selection of';
      if (facetNoUnisex && activeFilters.length <= 1) description += ` ${facetNoUnisex}`;
      if (subCategory && showSubCat) description += ` ${subCategory}`;
      else if (props?.algoliaCategories) description += `${formatCat(cats[2])} `;
      description += '. Your one-stop shop for';
      if (topNav) description += ` ${topNav}`;
      if (categoryWithoutGender && cats?.[0] !== 'whatsnew') description += ` ${categoryWithoutGender}`;
      description += ' from your favorite kids brands and more.';

      let heading = '';
      if (facetNoUnisex && activeFilters.length <= 1) heading += `${facetNoUnisex} `;
      if (subCategory && showSubCat) heading += `${subCategory}`;

      return {
        heading,
        title,
        description: description?.replace?.(/&/g, 'and')
      };
    }

    if (cats?.length === 2 && cats?.[0] === 'gear') {
      let title = '';
      if (facet && activeFilters.length <= 1) title += `${facet} `;
      if (categoryWithoutGender && showSubCat) title += `${formatCat(categoryWithoutGender)} `;
      title += '- Shop';
      if (topNav) title += ` ${topNav}`;
      if (!topNav && props?.algoliaCategories) title += ` ${formatString('capitalize', cats[0])}`;
      title += ' | Maisonette';

      let description = 'Shop Maisonette\'s curated selection of';
      if (facet && activeFilters.length <= 1) description += ` ${facet}`;
      if (categoryWithoutGender && showSubCat) description += ` ${formatCat(categoryWithoutGender)}`;
      description += '. Your one-stop shop for';
      if (topNav) description += ` ${topNav}`;
      if (!topNav && props?.algoliaCategories) title += ` ${formatString('capitalize', cats[0])}`;
      description += ' from your favorite kids brands and more.';

      let heading = '';
      if (facet && activeFilters.length <= 1) heading += ` ${facet}`;
      if (categoryWithoutGender && showSubCat) heading += ` ${categoryWithoutGender}`;

      return {
        heading,
        title,
        description: description.replace?.(/&/g, 'and')
      };
    }

    if (category === 'sale') {
      let title = '';
      if (facet && activeFilters.length <= 1) title += `${facet} - `;
      title += 'Shop Sale | Maisonette';

      let description = 'Shop Maisonette’s curated selection';
      if (facet && activeFilters.length <= 1) description += ` of ${facet}`;
      description += '. Your one-stop shop for Sale from your favorite kids brands and more.';
      let heading = '';
      if (facet && activeFilters.length <= 1) heading += `${facet} `;
      heading += 'Sale';

      return {
        heading,
        title,
        description: description.replace?.(/&/g, 'and')
      };
    }
  } else if (type === 'trend') {
    if (props.trend === 'just-in' && (!category || category.length === 0)) {
      return {
        heading: 'New Arrivals',
        title: 'New Arrivals & Trends for Babies, Kids & Adults Online | Maisonette',
        description: 'Discover newly curated clothing, toys, and more for all ages. From canvas shoes to bucket hats, Maisonette\'s New Arrivals has the latest trends online.'
      };
    }
    if (props.trend === 'selling-fast' && category === 'play') {
      return {
        heading: 'Best Selling Toys for Kids & Babies',
        title: 'Best Selling Toys for Kids & Babies | Maisonette',
        description: 'We’ve pulled together our best selling toys for kids and babies. Quickly see what our most wished-for and fastest selling toys are for this holiday season.'
      };
    }
  } else if (type === 'edit') {
    if (props.edit === 'mythical-creatures-costumes') {
      return {
        heading: 'Mythical Creature Costumes',
        title: 'Kids Mythical Creature Costumes - Fairy, Mermaid, Unicorn & More | Maisonette',
        description: 'Maisonette is your one-stop shop for Kid\'s Mythical Creature Costumes. From unicorns to mermaids to fairy costumes and more, shop kids halloween costumes.'
      };
    }

    if (props.edit === 'fairytale-costumes') {
      return {
        heading: 'Kids Fairytale Costumes',
        title: 'Kids Fairytale Costumes - Shop Princess, Knight, Pirate Costumes & More | Maisonette',
        description: 'Let your prince or princess to dress the part for Halloween! Shop Maisonette\'s selection of kids fairytale costumes from princess dresses to pirate costumes and more.'
      };
    }

    if (props.edit === 'superhero-costumes') {
      return {
        heading: 'Kids Superhero Costumes',
        title: 'Kids Superhero Costumes - Superhero Costumes for Girls & Boys | Maisonette',
        description: 'Let your little one save the day with Maisonette\'s selection of kids superhero costumes for girls and boys. Shop heirloom quality hats, capes and more.'
      };
    }

    if (props.edit === 'when-i-grow-up-costumes') {
      return {
        heading: 'Kids Career Costumes',
        title: 'Kids Career Costumes - Shop Kids Police Officer, Chef, Astronaut Costumes & More | Maisonette',
        description: 'What does your kid want to be when they grow up? Shop kids career costumes from Maisonette. From police officers to chefs to astronaut costumes, get it here.'
      };
    }

    if (props.edit === 'holiday-dressing' && category === 'baby') {
      return {
        heading: 'Baby Holiday Clothes',
        title: 'Baby Christmas Outfits & Clothes | Maisonette',
        description: 'Celebrate in style with baby Christmas outfits and clothes from Maisonette. Shop our curated selection of holiday clothes for babies, infants and newborns.'
      };
    }
    if (props.edit === 'holiday-dressing' && category === 'kids') {
      return {
        heading: 'Kids Holiday Clothes',
        title: 'Kids Christmas Outfits & Clothes | Maisonette',
        description: 'Celebrate in style with kids\' Christmas outfits and clothes from Maisonette. Shop our curated selection of kids holiday clothes, accessories, and more.'
      };
    }

    if (props.edit === 'holiday-dressing' && (activeFilterIds?.includes('812y') || props?.variants?.includes('8-12y'))) {
      return {
        heading: 'Teen Holiday Clothes',
        title: 'Teen Holiday Clothes | Maisonette',
        description: 'Maisonette is your one-stop shop for babies, kids, teens and adults. Show your teen Maisonette\'s selection of teen holiday clothes for a look you\'ll both love.'
      };
    }
    if (props.edit === 'holiday-dressing' && activeFilterIds?.includes('adults')) {
      return {
        heading: 'Women\'s Holiday Clothes',
        title: 'Christmas & Holiday Clothes, Sweaters, Dresses & More | Maisonette',
        description: 'Maisonette is your one-stop shop for everyone in the family. Shop women\'s holiday and Christmas clothes from Christmas sweaters to dresses and more.'
      };
    }

    if (props.edit === 'holiday-dressing' && category === 'whatsnew_shops_thepetshop') {
      return {
        heading: 'Pet Holiday Clothes',
        title: 'Pet Holiday Clothes - Dog & Cat Christmas Sweaters & More | Maisonette',
        description: 'Outfit the whole family this year, including the pets! Shop Maisonette\'s selection of pet holiday clothes, like dog and cat Christmas sweaters and more.'
      };
    }

    if (props.edit === 'holiday-pajamas') {
      return {
        heading: 'Holiday & Christmas Pajamas',
        title: 'Holiday & Christmas Pajamas for the Whole Family | Maisonette',
        description: 'Shop Maisonette\'s selection of holiday and Christmas pajamas for the whole family. From robes to nightgowns to footies and more, shop holiday pajamas here.'
      };
    }
    if (props.edit === 'family-matching') {
      return {
        heading: 'Matching Family Christmas Pajamas',
        title: 'Matching Family Christmas Pajamas | Maisonette',
        description: 'Get the whole gang together with matching family Christmas pajamas. Shop Maisonette\'s curated selection of matching pajama patterns and styles.'
      };
    }

    if (props.edit === 'stocking-stuffers') {
      return {
        heading: 'Stocking Stuffers',
        title: 'Stocking Stuffers for Kids & Babies | Maisonette',
        description: 'Shop Maisonette\'s stocking stuffers for kids and babies. Find the best selection of age appropriate stocking stuffers for the whole family.'
      };
    }
  } else if (type === 'lpc') {
    if (props.lpc === 'halloween-accessories') {
      return {
        heading: 'Halloween Accessories & Craft Supplies',
        title: 'Halloween Accessories & Craft Supplies | Maisonette',
        description: 'Keep the festivities alive with spooky crafts and more. Shop Maisonette\'s selection of Halloween accessories including Halloween craft supplies, and more.'
      };
    }

    if (props.lpc === 'halloween-pajamas') {
      return {
        heading: 'Halloween Pajamas',
        title: 'Baby & Kids Halloween Pajamas | Maisonette',
        description: 'Themed pajamas are our favorite and Maisonette has you covered when it comes to baby and kids Halloween pajamas. Shop Halloween onesies, footies, sets and more.'
      };
    }
  } else if (type === 'brand') {
    const brand = props.brand?.name;
    if (!brand) return false;

    const categories = Object.values(props.categories?.active ?? [])?.map?.((x) => x.name);
    const facets = props?.facets?.find?.((x) => x.id === 'category')?.values?.filter((x) => x.selected);

    const facet = facets?.length === 1
      ? facets[0]?.name
      : null;

    const productType = [...categories]?.pop();
    const cat = categories?.length === 3 ? categories[1] : props.algoliaCategories;

    let title = brand;

    if (facet) title += ` ${facet}`;

    if (productType) {
      title += ` ${productType}`;
      title += cat
        ? ` - Shop ${cat} by Brand | Maisonette`
        : ' - Shop by Brand | Maisonette';
    } else if (cat) {
      title += ` ${cat} - Shop by Brand | Maisonette`;
    } else {
      title += ' - Shop by Brand | Maisonette';
    }

    let description = `Shop customer favorites from ${brand}. Maisonette features top brands like ${brand}`;
    if (productType) description += ` ${productType}`;
    if (facet) description += ` ${facet}`;
    description += ' for kids\' and baby clothing, toys, home decor and more.';

    let heading = brand;
    if (productType) heading += ` ${productType}`;
    else if (cat) heading += ` ${cat}`;
    if (facet) heading += ` ${facet}`;

    return {
      heading,
      title,
      description: description.replace?.(/&/g, 'and')
    };
  }

  return false;
};

const getOverrides = (categories = [], type, props = null) => {
  const category = typeof categories[categories.length - 1] === 'string'
    ? categories[categories.length - 1]
    : categories[categories.length - 1]?.id;
  return getOverrideMeta(category, type, props);
};

export default getOverrides;
